import noUiSlider from "nouislider";

export function init() {
	let priceSlider = document.getElementById("priceSlider");
	let minPrice = document.getElementById("minPrice");
	let maxPrice = document.getElementById("maxPrice");

	let lengthSlider = document.getElementById("lengthSlider");
	let minLength = document.getElementById("minLength");
	let maxLength = document.getElementById("maxLength");

	function checkEl(element) {
		if (
			typeof element != "undefined" &&
			element != null &&
			element.value !== ""
		) {
			return true;
		} else {
			return false;
		}
	}

	let startPrice = checkEl(minPrice) ? minPrice.value : 0;
	let toPrice = checkEl(maxPrice) ? maxPrice.value : 1000000;

	let shortest = checkEl(minLength) ? minLength.value : 0;
	let longest = checkEl(maxLength) ? maxLength.value : 100;

	if (checkEl(priceSlider)) {
		noUiSlider.create(priceSlider, {
			start: [startPrice, toPrice],
			step: 10000,
			tooltips: [true, true],
			connect: true,
			range: {
				min: parseInt(minPrice.getAttribute("data-min"), 10),
				max: parseInt(maxPrice.getAttribute("data-max"), 10),
			},
			format: {
				// 'to' the formatted value. Receives a number.
				to: function (value) {
					return Number(value).toFixed(0);
				},
				// 'from' the formatted value.
				// Receives a string, should return a number.
				from: function (value) {
					return Number(value).toFixed(0);
				},
			},
		});
		priceSlider.noUiSlider.on("update", function (values, handle) {
			var value = values[handle];
			if (handle) {
				maxPrice.value = value;
			} else {
				minPrice.value = value;
			}
		});
	}

	if (checkEl(lengthSlider)) {
		noUiSlider.create(lengthSlider, {
			start: [shortest, longest],
			step: 5,
			tooltips: [true, true],
			connect: true,
			range: {
				min: parseInt(minLength.getAttribute("data-min"), 10),
				max: parseInt(maxLength.getAttribute("data-max"), 10),
			},
			format: {
				// 'to' the formatted value. Receives a number.
				to: function (value) {
					return Number(value).toFixed(0);
				},
				// 'from' the formatted value.
				// Receives a string, should return a number.
				from: function (value) {
					return Number(value).toFixed(0);
				},
			},
		});
		lengthSlider.noUiSlider.on("update", function (values, handle) {
			var value = values[handle];
			if (handle) {
				maxLength.value = value;
			} else {
				minLength.value = value;
			}
		});
	}
}
